import { Reveal } from "./Reveal";
import { GALLERY } from "@/data/business";
import { motion } from "framer-motion";

const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 sm:py-32 bg-white"
    >
      <div className="container-nitc">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <p className="text-eyebrow">Showroom &amp; warehouse</p>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl font-semibold text-[color:var(--nitc-ink)] leading-[1.05] tracking-tight">
              A walk through the<br />
              <span className="italic font-light">NITC space.</span>
            </h2>
          </div>
          <p className="text-[color:var(--nitc-text)] sm:max-w-sm">
            From our showroom in Nagawara to the warehouse stacks — see the material we hand-pick for
            every project.
          </p>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[180px] sm:auto-rows-[220px] lg:auto-rows-[260px] gap-3 sm:gap-4">
          {GALLERY.map((g, i) => (
            <motion.div
              key={g.src}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.05 }}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden rounded-lg ring-1 ring-black/5 ${g.span}`}
            >
              <img
                src={g.src}
                alt={g.label}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/0 to-transparent opacity-90" />
              <div className="absolute bottom-3 left-4 right-4 flex items-end justify-between">
                <p className="text-white font-display text-base sm:text-lg">{g.label}</p>
                <span className="text-[10px] tracking-[0.22em] uppercase text-white/70">
                  0{i + 1}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
